import { createDynamicSlice } from ".";
import { fetchAuditFormsThunk } from "../thunks/auditFormsThunk";

export const auditFormsSlice = createDynamicSlice({
  name: "auditForms",
  thunk: fetchAuditFormsThunk,
  listMode: true,
  resetActionName: "resetAuditForms",
});

export const auditFormsReducer = auditFormsSlice.reducer;
export const { resetAuditForms } = auditFormsSlice.actions;
